import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=40311cdc&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=40311cdc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40311cdc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40311cdc')) {
      api.createRecord('40311cdc', component.options)
    } else {
      api.reload('40311cdc', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=40311cdc&scoped=true&", function () {
      api.rerender('40311cdc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2y8fNzgd9weJ3/JS/comp/PopupBox.vue"
export default component.exports